const userPopup = {
  overview: 'Meine Übersicht',
  helloMessage: 'Hello, {username}',
}

export default userPopup
